export default "__VITE_PUBLIC_ASSET__6b0390d1__"